import React, { PureComponent } from 'react';

import { injectIntl, InjectedIntl } from 'react-intl';

import CommentIcon from '@atlaskit/icon/glyph/comment';
import { token } from '@atlaskit/tokens';

import { ScreenReadersOnly } from 'src/components/accessibility';
import { IconWithCountWrapper } from 'src/styles';
import { PullRequest } from 'src/types/pull-requests-table';
import { hasUnseenActivity } from 'src/utils/pull-requests/pull-request-activity';

import messages from './comments.i18n';
import * as styles from './comments.style';

type CommentsProps = {
  intl: InjectedIntl;
  pullRequest: PullRequest;
};

export default injectIntl(
  class Comments extends PureComponent<CommentsProps> {
    render() {
      const { intl, pullRequest } = this.props;
      const { comment_count: commentCount } = pullRequest;

      if (!commentCount) {
        return null;
      }

      return (
        <IconWithCountWrapper>
          <styles.IconContainer
            hasUnseenActivity={hasUnseenActivity(pullRequest)}
          >
            <CommentIcon
              label={
                hasUnseenActivity(pullRequest)
                  ? intl.formatMessage(messages.unseenActivityLabel)
                  : ''
              }
              primaryColor={token('color.icon')}
              size="medium"
            />
          </styles.IconContainer>
          <span aria-hidden="true">{commentCount}</span>
          <ScreenReadersOnly>
            {intl.formatMessage(messages.label, {
              commentCount,
            })}
          </ScreenReadersOnly>
        </IconWithCountWrapper>
      );
    }
  }
);
